import React from 'react';
import { useVisitContext } from '@hooks';
import { HeaderLayout } from '@layouts';
import errorVisitBg from '@assets/error-visit-bg.png';
import { useStyles } from './styles';

const ErrorVisitScreen = () => {
  const classes = useStyles();
  const { errorMessage } = useVisitContext();

  console.error('error-visit-screen');
  return (
    <HeaderLayout>
      <div className={classes.container}>
        <div>
          <img src={errorVisitBg} alt="error-bg" />
          <div className={classes.textPart}>
            <p className={classes.title}>Oops!</p>
            <p className={classes.subTitle}>
              {errorMessage || 'Something went wrong'}
            </p>
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
};

export default ErrorVisitScreen;
